import { format, isThisYear, isToday, isYesterday } from 'date-fns';

import { type AppDate, appDateToDate } from './appDate';

/**
 * Right-aligned timestamp shown next to a channel row or message
 * bubble. Matches the design's "Mar 9", "Sep 3, 2025", "Sep 23, 2025"
 * mix — drop the year when it's the current year, except never drop
 * it on dates older than ~9 months to avoid ambiguous labels.
 *
 * Accepts either an `AppDate` (message timestamps from the canonical model) or
 * an ISO string (channel view types that still carry strings).
 */
export function formatChannelTimestamp(
  value: AppDate | string | undefined,
): string {
  if (!value) return '';
  const date = appDateToDate(value);
  if (isToday(date)) return format(date, 'h:mm a');
  if (isYesterday(date)) return 'Yesterday';
  if (isThisYear(date)) return format(date, 'MMM d');
  return format(date, 'MMM d, yyyy');
}

/**
 * Long-form timestamp for individual message bubbles ("Sep 3, 2025"
 * — matches the design where each bubble shows the full date).
 */
export function formatMessageTimestamp(
  value: AppDate | string | undefined,
): string {
  if (!value) return '';
  const date = appDateToDate(value);
  if (isThisYear(date)) return format(date, 'MMM d');
  return format(date, 'MMM d, yyyy');
}
